import { http } from '@/lib/http';
import type { APIResponse } from '@/types';
import { OauthLink } from '../types';

export type GetOauthLinkResponse = APIResponse<Array<OauthLink>>;

export const getOauthLink = async () => {
  return await http<GetOauthLinkResponse>('/user/v1/oauth/link');
};
